import { useMobile } from 'common-nextjs';
import React, { CSSProperties, useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';
import FreestarAd from '~/components/FreestarAd';
import ItemThumbnailGridLessColumns from '~/components/ItemGrids/ItemThumbnailGridLessColumns';
import ItemThumbnail from '~/components/ItemThumbnail/ItemThumbnail';
import useItemGridMeta from '~/hooks/useItemGridMeta';
import { RailsThumbnailItem } from '~/typings/services/rails/item';

interface Props {
  adRowFrequency?: number;
  adSlots: string[];
  adStyle?: CSSProperties;
  mobileAdRowFrequency?: number;
  items: RailsThumbnailItem[];
  showAds?: boolean;
}

function widthToColumns(width: number) {
  if (width >= 1536) {
    return 4;
  } else if (width >= 1280) {
    return 4;
  } else if (width >= 1024) {
    return 3;
  } else if (width >= 768) {
    return 2;
  } else {
    return 2;
  }
}

const ItemThumbnailGridWithAdsLessColumns: React.FC<Props> = ({
  adRowFrequency = 3,
  adSlots,
  adStyle,
  items,
  mobileAdRowFrequency = 3,
  showAds = true,
}) => {
  useItemGridMeta(items);

  const mobile = useMobile();
  const windowSize = useWindowSize({
    initialWidth: mobile ? 360 : 1280,
  });

  const [columns, setColumns] = useState(() =>
    widthToColumns(windowSize.width),
  );

  useEffect(() => {
    setColumns(widthToColumns(windowSize.width));
  }, [windowSize.width]);

  // -1 because it increments before it renders
  let adCount = -1;

  return (
    <ItemThumbnailGridLessColumns>
      {items.map((item, i) => {
        let showAd = false;
        if (showAds) {
          if (i > 0) {
            if (mobile) {
              showAd = i % (columns * mobileAdRowFrequency) === 0;
            } else {
              if (adCount === -1) {
                showAd = i % columns === 0;
              } else {
                showAd = (i - columns) % (columns * adRowFrequency) === 0;
              }
            }
          }

          if (showAd) {
            adCount += 1;
          }
        }

        return (
          <React.Fragment key={item.id}>
            {showAd && adSlots[adCount % adSlots.length] && (
              <FreestarAd
                containerClassName="col-span-full"
                adSlot={adSlots[adCount % adSlots.length]}
                id={`sidelineswap_incontent_${adCount + 1}`}
                style={adStyle}
              />
            )}
            <ItemThumbnail item={item} position={i} preloadImage />
          </React.Fragment>
        );
      })}
    </ItemThumbnailGridLessColumns>
  );
};

export default ItemThumbnailGridWithAdsLessColumns;
